import React from "react"
import { Box, Typography, makeStyles } from "@material-ui/core"
import { useTranslation } from "react-i18next"
import { DATE_PICKER_FORMAT } from "../../utils"
import moment from "moment"
import { useSelector } from "react-redux"
import { BasicTable } from "../common/Table"
import useUser from "../../utils/customHooks/useUser"

const useStyles = makeStyles((theme) => ({
	item: {
		marginBottom: 10,
	},
	color: {
		width: 14,
		minWidth: 14,
		height: 14,
		borderRadius: 3,
		marginRight: 9,
	},
	heading: {
		color: theme.palette.grey["D100"],
	},
	description: {
		// overflow: "hidden",
		// textOverflow: "ellipsis",
		// display: "-webkit-box",
		// "-webkit-line-clamp": 1 /* Number of lines to display */,
		// "-webkit-box-orient": "vertical",
	},
	exportTable: {
		maxHeight: "fit-content",
		"& .MuiTableCell-root": {
			borderBottom: `1px solid ${theme.palette.grey["D400"]}`,
		},
	},
}))

const ExportEventTable = ({ isLoading }) => {
	const [t] = useTranslation("global")
	const classes = useStyles()
	const { getUserNameById } = useUser()

	const events = useSelector((state) => state.events.selectedEvents)

	function RenderName(params) {
		return (
			<Box display="flex" alignItems="center" className={classes.item}>
				<Box display="flex" alignItems="center">
					<div className={classes.color} style={{ backgroundColor: params?.row?.colour }}></div>
					<Typography variant="body1" color="primary">
						{params?.row?.name}
					</Typography>
				</Box>
			</Box>
		)
	}

	function RenderUser(params) {
		const userName = getUserNameById(params?.row?.userid)
		return (
			<Box display="flex" alignItems="center" className={classes.item}>
				{userName}
			</Box>
		)
	}

	const getColumns = () => {
		return [
			{
				field: "name",
				headerName: t("event.field.eventName"),
				headerAlign: "left",
				sortable: false,
				flex: 1,
				width: "35%",
				align: "left",
				renderCell: (params) => RenderName(params),
			},
			{
				field: "userid",
				headerName: t("event.field.createdBy"),
				headerAlign: "left",
				sortable: false,
				flex: 0.3,
				width: "15%",
				align: "left",
				renderCell: (params) => RenderUser(params),
			},
			{
				field: "start_date",
				headerName: t("event.field.startDate"),
				headerAlign: "right",
				sortable: false,
				flex: 0.3,
				width: "10%",
				align: "right",
				renderCell: (params) => (
					<Box display="flex" alignItems="center" className={classes.item}>
						{moment(params?.row?.start_date).format(DATE_PICKER_FORMAT)}
					</Box>
				),
			},
			{
				field: "end_date",
				headerName: t("event.field.endDate"),
				headerAlign: "right",
				sortable: false,
				flex: 0.3,
				width: "10%",
				align: "right",
				renderCell: (params) => (
					<Box display="flex" alignItems="center" className={classes.item}>
						{moment(params?.row?.end_date).format(DATE_PICKER_FORMAT)}
					</Box>
				),
			},
			{
				field: "description",
				headerName: t("event.field.description"),
				headerAlign: "left",
				sortable: false,
				flex: 0.3,
				width: "30%",
				align: "left",
				renderCell: (params) => (
					<Box title={params?.row?.description} className={classes.description}>
						{params?.row?.description}
					</Box>
				),
			},
		]
	}

	return (
		<>
			{events.length > 0 && (
				<BasicTable
					columns={getColumns()}
					rows={events}
					isLoading={isLoading}
					pageInfo={{
						page: 1,
						pageSize: events?.length,
						rowsPerPageOptions: [5, 10, 20, 50],
						totalRowCount: events.length,
						paginationMode: "server",
						handlePageChange: () => {},
						handlePageSizeChange: () => {},
					}}
					showPagination={false}
					sortInfo={{
						sortingMode: "server",
						sortModel: [],
						onSortModelChange: () => {},
					}}
					checkboxSelection={false}
					footerInfo={{
						hideFooter: false,
						hideSelectionCount: true,
						hidePagination: true,
					}}
					topBarInfo={{
						show: true,
						rightSection: "",
					}}
					totalCountText={t("event.events")}
					showDownloadButton={false}
					showColumnsButton={false}
					customClass={classes.exportTable}
				/>
			)}
		</>
	)
}

export default ExportEventTable
